import { createClient } from '@supabase/supabase-js';

// Public anon key; access to editing is enforced by Supabase row-level security.
const SUPABASE_URL = 'https://fomiczmzcckipevbvpok.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZvbWljem16Y2NraXBldmJ2cG9rIiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTI2NjY4MjQsImV4cCI6MjEwODI0MjgyNH0.uvGiL0FkPSttZPj7YUdTC3C94K7iXBWafBRcqC5sE-g';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: { persistSession: true, autoRefreshToken: true }
});